import React from 'react';
import { features } from '../data/mock';
import { ArrowRight } from 'lucide-react';
import PhoneMockup from './PhoneMockup';

const featureVariant = { google: 'google', social: 'instagram', consciencia: 'counts' };

const Features = () => {
  return (
    <section id="como-funciona" className="relative py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center mb-16">
          <p className="text-cyan-300 text-sm font-semibold uppercase tracking-widest mb-3">Como funciona</p>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
            <span className="text-white">Como o Anjora te ajuda</span>
            <br />
            <span className="gradient-text">a vencer o vício em apostas</span>
          </h2>
        </div>

        <div className="space-y-8 md:space-y-12">
          {features.map((f, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <div
                key={f.id}
                className="gradient-border p-6 md:p-12 grid md:grid-cols-2 gap-8 md:gap-12 items-center"
              >
                <div className={`hidden md:flex justify-center overflow-hidden ${reverse ? 'md:order-2' : ''}`}>
                  <div className="transform md:scale-90">
                    <PhoneMockup variant={featureVariant[f.id]} highlighted scan={false} />
                  </div>
                </div>
                <div className={reverse ? 'md:order-1' : ''}>
                  <div
                    className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold mb-5"
                    style={{
                      background: `linear-gradient(135deg, ${f.accentFrom}22, ${f.accentTo}22)`,
                      border: `1px solid ${f.accentFrom}44`,
                      color: f.accentFrom,
                    }}
                  >
                    {f.tag}
                  </div>
                  <h3 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-4">
                    {f.title}
                  </h3>
                  <p className="text-white/65 text-base md:text-lg leading-relaxed mb-6">
                    {f.description}
                  </p>
                  <button className="group inline-flex items-center gap-2 text-white font-semibold text-sm hover:gap-3 transition-all">
                    <span
                      className="px-5 py-3 rounded-full"
                      style={{
                        background: `linear-gradient(135deg, ${f.accentFrom}, ${f.accentTo})`,
                      }}
                    >
                      {f.cta}
                    </span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
